module.exports = __webpack_public_path__ + "img/portfolio-icon.a0ecf510.svg";